<template id="orgDetailsTmpl">
		<ct-main-layout-appcommerciale :backurl="backurl" :breadcrumbs="breadcrumbs">
			
			<v-card v-if="detailOrg != null">

				<!-- TITLE -->
				<v-card-title>
					{{ $t('lbl.organization')}}: {{detailOrg.organization_name}}
				</v-card-title>
			
				<!-- MODIFICA NOME ORGANIZZZIONE - START -->
				<v-card-text class="mt-2 mb-2">
					<v-dialog v-model="dialogChangeOrgNameIsOpen" persistent max-width="500px">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" class="button-main ma-1" ><v-icon left dark>create</v-icon>{{ $t('btn.edit')}}</v-btn>
						</template>

						<v-form ref="formChangeName" v-model="validFrmChangeName" lazy-validation>
							<v-card>
								<v-card-title>{{ $t('lbl.changeNameOrg')}}</v-card-title>
								
								<v-card-text>
									<v-layout row wrap> 
										<v-flex xs12><v-text-field v-model="newNameOrganization" :rules="nameRules" :label="$t('lbl.organizationName')" required></v-text-field></v-flex>
									</v-layout>
								</v-card-text>
							
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn class="button-main ma-1" v-on:click.native="dialogChangeOrgNameIsOpen = false"><v-icon left dark>close</v-icon>{{ $t('btn.closeDialog')}}</v-btn>
									<v-btn class="button-main ma-1" v-on:click="changeOrgName()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.changeNameOrganization')}}</v-btn>
								</v-card-actions>
							</v-card>
						</v-form>
					</v-dialog>
				</v-card-text>
				<!-- MODIFICA NOME ORGANIZZAZIONE - END -->

				<v-tabs slider-color="primary" center-active>
					<v-tab ripple>{{ $t('lbl.projects')}}</v-tab>
					<v-tab ripple>{{ $t('lbl.logo')}}</v-tab>
					<v-tab ripple>{{ $t('lbl.users')}}</v-tab>
					<v-tab-item>
						<v-card>
							<v-card-text>
								<ct-org-projects ref="list_projects" :orgitem="detailOrg"></ct-org-projects> 
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<v-card>
							<v-card-text>
								<ct-form-upload-logo :orgitem="detailOrg"></ct-form-upload-logo> 
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item>
						<v-card>
							<v-card-text>
								<ct-org-users :orgitem="detailOrg"></ct-org-users>
							</v-card-text>
						</v-card>
					</v-tab-item>
								
				</v-tabs>
			</v-card>

			<v-card class="mb-2" v-else>
				<v-card-text>
					{{ $t('lbl.wait')}}
				</v-card-text>
			</v-card>		

		</ct-main-layout-appcommerciale>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctOrgProjects from "@/components/appcommerciale/ctOrgProjects.vue";
import ctFormUploadLogo from "@/components/appcommerciale/ctFormUploadLogo.vue";
import ctOrgUsers from "@/components/appcommerciale/ctOrgUsers.vue";

export default {
	i18n,
	data: () => ({
		backurl: '/appcommerciale',
		breadcrumbs:[],
		dialogChangeOrgNameIsOpen: false,
		validFrmChangeName: false,
		newNameOrganization: '',
		nameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		detailOrg: null,
	}),
	components: {
		'ct-org-projects': ctOrgProjects,
		'ct-org-users': ctOrgUsers,
		'ct-form-upload-logo': ctFormUploadLogo,
	},
	mounted() 
	{
		//=== NAVIGATION BAR
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appcommerciale'), disabled: false, href: '/tools/appcommerciale' }
		]

		//=== START LISTEN EVENTS
		events.$on(constants.EVENT_DO_LOAD_ORG_DETAILS, () => {
			this.loadOrgDetails();
		});

		//=== STARTUP
		this.loadOrgDetails();
		
		//=== RESET ALERT
		this.$root.changesNotSavedFlg = false;
	},
	destroyed() 
	{
		//=== STOP LISTEN EVENTS
		events.$off(constants.EVENT_DO_LOAD_ORG_DETAILS);
	},
	methods: {
		loadOrgDetails() 
		{
			var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/'+ this.$route.params.orgId;
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadOrgDetails, 'err.loadingOrg');
		},
		callbackLoadOrgDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData) && !this.isEmptyString(responseData.organization_id))
			{
				//=== SETTO DETTAGLIO ORGANIZZAZIONE
				this.detailOrg = responseData;

				this.breadcrumbs.push({text: this.detailOrg.organization_name, disabled: false});

				//=== ALLINEO NOME SU OGGETTO NUOVO NOME
				this.newNameOrganization = this.detailOrg.organization_name;

				//=== LANCIO EVENTO CARICA LISTA PROGETTI
				events.$emit(constants.EVENT_DO_LOAD_PROJECT_LIST, this.detailOrg.organization_id);
			} 
			else 
			{
				this.$root.setDialogMsg(i18n.t('err.loadingOrg'));
			}
		},
		changeOrgName() 
		{
			if (this.$refs.formChangeName.validate()) 
			{
				if(!this.isEmptyString(this.newNameOrganization))
				{
					var endpoint2go = constants.ENDPOINT_ORGANIZATIONS + '/' + this.detailOrg.organization_id;
					var obj2send = {organization_name: this.newNameOrganization};
					
					//console.log("UPDATE ORGANIZATION: " + endpoint2go);	
					//console.log(JSON.stringify(obj2send));	

					this.$root.genericPatchAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackChangeOrgName, 'err.savingOrg');	

				} 
				else 
				{
					this.$root.setDialogMsg(i18n.t('err.newOrgNameNotValid'));
				}
			}	
		},
		callbackChangeOrgName(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				if(!this.isEmptyString(responseData.organization_name))
				{
					this.detailOrg.organization_name = responseData.organization_name;
				}
				if(!this.isEmptyString(responseData.last_updated))
				{
					this.detailOrg.last_updated = responseData.last_updated;
				}
				if(!this.isEmptyString(responseData.last_update_user))
				{
					this.detailOrg.last_update_user = responseData.last_update_user;
				}
				this.newNameOrganization = this.detailOrg.organization_name;
				this.dialogChangeOrgNameIsOpen = false;
				this.$root.setDialogMsg(i18n.t('msg.saveok'));
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.savingOrg"));
			}
		},
		
	}
}
</script>